<template>
    <div class="daily-deals-inner">
        <div class="daily-deals-top">
            <a :href="productUrl" class="product-image">
                <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product-image">
            </a>
        </div>

        <a :href="productUrl" class="product-name">
            <h6>{{ product.name }}</h6>
        </a>

        <div class="deal-progress">
            <div class="deal-stock">
                <div class="stock-available">
                    {{ $trans('storefront::product_card.available') }}
                    <span>{{ product.pivot.qty }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductCardMixin from '../mixins/ProductCardMixin';

    export default {
        mixins: [
            ProductCardMixin,
        ],

        props: ['product'],
    };
</script>
